import { IconButton, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import "./students.css";
import StudentCard from "../../../components/StudentCard";
import Lang from "../../../components/Lang";

export default function Students(props) {
  let { students } = props.customer;
  let navigate = useNavigate();
  return (
    <section className="customer-roster">
      <header className="roster-header">
        <h2 className="roster-title">
          <Lang w="students" />
        </h2>
        <Tooltip title="Add a new student">
          <IconButton
            className="add-student-btn"
            onClick={() => navigate("/newstudent/" + props.customer._id)}
            size="medium"
          >
            <AddIcon />
          </IconButton>
        </Tooltip>
      </header>

      <div className="flex flex-wrap gap-4 items-center">
        {students.map((s) => (
          <StudentCard student={s} key={s._id} />
        ))}
        {students.length === 0 && (
          <div className="text-slate-400 italic py-4">
            No students enrolled yet.
          </div>
        )}
      </div>
    </section>
  );
}

